/* eslint-disable react/prop-types */
/* eslint-disable radix */
/* eslint-disable prefer-const */
import React, { useContext } from 'react';

import { Typography } from '@mui/material';
import { ConfigCard } from '../../../../shared/components/ConfigCard';

import { CustomCardContent } from './styles';
import { GeneralContext } from '../../../../core/app-context/GeneralContext';
import CustomSwitch from './components/CustomSwitch';

export default function DevolutionPreferences({
  autoApprove,
  onAutoApproveChange,
  considerItems,
  onConsiderItemsChange,
  searchVtex,
  onSearchVtexChange,
  enableReturnMethodSelectionEmail,
  onEnableReturnMethodSelectionEmailChange,
  enableOrderNumberInput,
  onEnableOrderNumberInputChange,
  searchMemphis,
  onSearchMemphisChange,
}) {
  const { setInfoMessage } = useContext(GeneralContext);
  return (
    <ConfigCard
      title="Preferências do fluxo de devolução"
      flexWrap="wrap"
      justifyContent="flex-start"
    >
      <CustomCardContent style={{ display: 'flex', flexDirection: 'column' }}>
        <CustomSwitch
          label="Aprovar pedidos automaticamente"
          tooltipContent={
            <Typography>
              Faz com que os pedidos sejam aprovados automaticamente.
            </Typography>
          }
          checked={autoApprove || false}
          onChange={onAutoApproveChange}
        />
      </CustomCardContent>
      <CustomCardContent style={{ display: 'flex', flexDirection: 'column' }}>
        <CustomSwitch
          label="Enviar email de seleção de método de devolução"
          tooltipContent={
            <Typography>
              Habilita o envio do email de seleção do método de devolução para o
              cliente.
            </Typography>
          }
          checked={enableReturnMethodSelectionEmail || false}
          onChange={onEnableReturnMethodSelectionEmailChange}
        />
      </CustomCardContent>
      <CustomCardContent>
        <CustomSwitch
          label="Considerar items do pedido"
          tooltipContent={
            <Typography>
              Habilita a entrada de informações dos items do pedido de
              devolução.
            </Typography>
          }
          checked={considerItems || false}
          onChange={(event) => {
            if (searchVtex) {
              onSearchVtexChange({ target: { checked: false } });
            }
            onConsiderItemsChange(event);
          }}
        />
      </CustomCardContent>
      <CustomCardContent style={{ display: 'flex', flexDirection: 'column' }}>
        <CustomSwitch
          label="Ativar entrada do número do pedido"
          tooltipContent={
            <Typography>
              Habilita o campo para entrada no número do pedido na tela inicial
              do fluxo de criação do pedido.
            </Typography>
          }
          checked={enableOrderNumberInput || false}
          onChange={onEnableOrderNumberInputChange}
        />
      </CustomCardContent>
      <CustomCardContent>
        <CustomSwitch
          label="Busca de pedidos VTEX"
          tooltipContent={
            <>
              <Typography>
                Habilita a busca das informações dos items do pedido na
                plataforma da VTEX.
              </Typography>
              <br />
              <Typography style={{ fontWeight: 'bold' }}>
                Apenas efetivo com a opção "Considerar itens do pedido"
                habilitada e com as credenciais VTEX configuradas no menu de
                integrações.
              </Typography>
            </>
          }
          checked={searchVtex || false}
          onChange={(event) => {
            if (!considerItems) {
              setInfoMessage(
                'Para habilitar a busca de pedidos VTEX, é necessário habilitar a opção "Considerar itens do pedido"',
              );
              return;
            } else if (searchMemphis) {
              setInfoMessage(
                'Para habilitar a busca de pedidos VTEX, é necessário desabilitar a opção "Busca de pedidos Memphis"',
              );
              return;
            } else {
              onSearchVtexChange(event);
            }
          }}
        />
      </CustomCardContent>
      <CustomCardContent style={{ display: 'flex', flexDirection: 'column' }}>
        <CustomSwitch
          label="Busca de pedidos Memphis"
          tooltipContent={
            <Typography>
              Habilita a busca das informações dos items do pedido na plataforma
              da Memphis.
            </Typography>
          }
          checked={searchMemphis || false}
          onChange={(event) => {
            if (searchVtex) {
              setInfoMessage(
                'Para habilitar a busca de pedidos Memphis, é necessário desabilitar a opção "Busca de pedidos VTEX"',
              );
              return;
            } else {
              onSearchMemphisChange(event);
            }
          }}
        />
      </CustomCardContent>
    </ConfigCard>
  );
}
